import { HorizontalBar } from "react-chartjs-2";

export class NHorizontalBar extends HorizontalBar {
    isCancelled: boolean = undefined;

    constructor(props) {
        super(props);
        this.isCancelled = false;
    }

    componentWillUnmount() {
        this.isCancelled = true;

        if (this.chartInstance && this.chartInstance._tooltipElement) {
            this.chartInstance._tooltipElement.remove();
        }
    }
}
